import React from 'react';
import { Phone, Mail, MapPin, Calendar } from 'lucide-react';
import { formatDate } from '../../../utils/dateUtils';

interface ServiceRequest {
  id: string;
  customer_name: string;
  phone: string;
  email: string;
  description: string;
  status: string;
  created_at: string;
  state: string;
  city: string;
  area: string;
}

interface ServiceRequestRowProps {
  request: ServiceRequest;
  onStatusChange: (id: string, status: string) => void;
}

export default function ServiceRequestRow({ request, onStatusChange }: ServiceRequestRowProps) {
  return (
    <tr key={request.id}>
      <td className="px-6 py-4">
        <div className="text-sm font-medium text-gray-900">{request.customer_name}</div>
        <div className="flex items-center text-sm text-gray-500 mt-1">
          <Phone className="h-4 w-4 mr-1" />
          <a href={`tel:${request.phone}`} className="hover:text-blue-600">
            {request.phone}
          </a>
        </div>
        {request.email && (
          <div className="flex items-center text-sm text-gray-500 mt-1">
            <Mail className="h-4 w-4 mr-1" />
            <a href={`mailto:${request.email}`} className="hover:text-blue-600">
              {request.email}
            </a>
          </div>
        )}
      </td>
      <td className="px-6 py-4">
        <div className="text-sm text-gray-900">{request.description}</div>
        <div className="flex items-center text-sm text-gray-500 mt-1">
          <Calendar className="h-4 w-4 mr-1" />
          {formatDate(request.created_at)}
        </div>
      </td>
      <td className="px-6 py-4">
        <div className="flex items-start text-sm text-gray-500">
          <MapPin className="h-4 w-4 mr-1 mt-0.5" />
          <div>
            <div>{request.area}</div>
            <div>{request.city}, {request.state}</div>
          </div>
        </div>
      </td>
      <td className="px-6 py-4">
        <select
          value={request.status}
          onChange={(e) => onStatusChange(request.id, e.target.value)}
          className="block w-full pl-3 pr-10 py-2 text-base border-gray-300 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm rounded-md"
        >
          <option value="pending">Pending</option>
          <option value="assigned">Assigned</option>
          <option value="completed">Completed</option>
          <option value="cancelled">Cancelled</option>
        </select>
      </td>
    </tr>
  );
}